<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="margin-top:250px;">Dedication</h1>
<table>
<colgroup>
<col width="12%"/>
<col width="36%"/>
<col width="50%"/>
</colgroup>
<thead>
<tr class="header">
<td>Family </td>
<td>Surviving brother </td>
<td>
<p>V.K.N. Murthy Sikha</p>
</td>
</tr>
</thead>
<tbody>
<tr class="odd">
<td></td>
<td>Son</td>
<td>
<p>Naresh Sikha</p>
</td>
</tr>
<tr class="even">
<td></td>
<td>Daughter-in-law</td>
<td>
<p>Anna (Annapoorna Malyala) Sikha</p>
</td>
</tr>
<tr class="odd">
<td></td>
<td>Grandson</td>
<td>
<p>Ishwar Satyanand Sikha</p>
</td>
</tr>
<tr class="even">
<td></td>
<td>Daughter</td>
<td>
<p>Neela Moorty Mummaneni</p>
</td>
</tr>
<tr class="odd">
<td></td>
<td>Son-in-law</td>
<td>
<p>Bobby Mummaneni</p>
</td>
</tr>
<tr class="even">
<td></td>
<td>Granddaughter</td>
<td>
<p>Priya Mummaneni</p>
</td>
</tr>
<tr class="odd">
<td></td>
<td>Grandson</td>
<td>
<p>Jay Ramprasad Mummaneni</p>
</td>
</tr>
<tr class="even">
<td></td>
<td>Friends</td>
<td>
<p>Jim and Terri Cotts</p>
<p>Jim Aton and Carrie Trenholm</p>
<p>Roger Anderson and Sandy Gillies</p>
<p>Ed McNicoll</p>
<p>Eric Morrow</p>
</td>
</tr>
<tr class="odd">
<td></td>
<td>Mentors</td>
<td>
<p>The late Dr. Jack Adamson</p>
<p>The late Dr. William Mulder</p>
</td>
</tr>
<tr class="even">
<td></td>
<td>My students</td>
<td></td>
</tr>
<tr class="odd">
<td></td>
<td>and Lakshmi Sikha Moorty</td>
<td></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?6a993fe1